import { render, staticRenderFns } from "./WorkAnniversary.vue?vue&type=template&id=039e6430"
import script from "./WorkAnniversary.vue?vue&type=script&lang=js"
export * from "./WorkAnniversary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports